import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OohRoutesQueryVariables = Types.Exact<{
  agencyId: Types.Scalars['ID'];
  date?: Types.InputMaybe<Types.Scalars['Date']>;
}>;


export type OohRoutesQuery = { __typename?: 'Query', OohRoutes: Array<{ __typename?: 'OohRoute', id: any, routeName?: string | null, oohRouteStatus: Types.OohRouteStatus, couriers: Array<{ __typename?: 'Courier', courierId: number, indicative?: string | null, etaInterval: number }>, oohPoints: Array<{ __typename?: 'OohPoint', id: any, name?: string | null, capacity: number, oohType?: string | null, latitude: number, longitude: number, schedules?: Array<{ __typename?: 'OohPointSchedule', id: any, dayOfWeek: number, openingTime?: string | null, closingTime?: string | null }> | null, specialSchedules?: Array<{ __typename?: 'OohPointSpecialSchedule', id: any, bankHoliday: boolean, dayOfMonth: number, month: number, openingTime?: string | null, closingTime?: string | null }> | null }> }> };


export const OohRoutesDocument = gql`
    query OohRoutes($agencyId: ID!, $date: Date) {
  OohRoutes(agencyId: $agencyId, date: $date) {
    id
    routeName
    oohRouteStatus
    couriers {
      courierId
      indicative
      etaInterval
    }
    oohPoints {
      id
      name
      capacity
      oohType
      latitude
      longitude
      schedules {
        id
        dayOfWeek
        openingTime
        closingTime
      }
      specialSchedules {
        id
        bankHoliday
        dayOfMonth
        month
        openingTime
        closingTime
      }
    }
  }
}
    `;

/**
 * __useOohRoutesQuery__
 *
 * To run a query within a React component, call `useOohRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOohRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOohRoutesQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useOohRoutesQuery(baseOptions: Apollo.QueryHookOptions<OohRoutesQuery, OohRoutesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OohRoutesQuery, OohRoutesQueryVariables>(OohRoutesDocument, options);
      }
export function useOohRoutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OohRoutesQuery, OohRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OohRoutesQuery, OohRoutesQueryVariables>(OohRoutesDocument, options);
        }
export type OohRoutesQueryHookResult = ReturnType<typeof useOohRoutesQuery>;
export type OohRoutesLazyQueryHookResult = ReturnType<typeof useOohRoutesLazyQuery>;
export type OohRoutesQueryResult = Apollo.QueryResult<OohRoutesQuery, OohRoutesQueryVariables>;